import FJVideoRemoveBgAutoRight from '../view/FJVideoRemoveBgAutoRight';
import { memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJVideoRemoveBgAutoRightContainer = memo(() => {
    useLocalStore();
    const dispatch = useDispatch();
    const autoEditVideoInfo = useSelector(state => state.videoBgRemover.autoEditVideoInfo);
    const autoRemoverStatus = useSelector(state => state.videoBgRemover.autoRemoverStatus);
    const autoEditVideoIsUploading = useSelector(state => state.videoBgRemover.autoEditVideoIsUploading);
    const isPlay = useSelector(state => state.videoBgRemover.isPlaying);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const setCanvas = useCallback(
        canvas => {
            dispatch(FJActionVideoRemoveBg.setAutoRemoveBgCanvasAction(canvas));
        },
        [dispatch],
    );

    const playVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.playAction());
    }, [dispatch]);

    const pauseVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    if (headerTabIndex !== 0) {
        return null;
    }

    return (
        <FJVideoRemoveBgAutoRight
            setCanvas={setCanvas}
            playVideo={playVideo}
            pauseVideo={pauseVideo}
            isPlay={isPlay}
            autoEditVideoInfo={autoEditVideoInfo}
            autoRemoverStatus={autoRemoverStatus}
            autoEditVideoIsUploading={autoEditVideoIsUploading}
        />
    );
});

FJVideoRemoveBgAutoRightContainer.displayName = 'FJVideoRemoveBgAutoRightContainer';
export default FJVideoRemoveBgAutoRightContainer;
